import { extend } from 'flarum/extend';
import Button from 'flarum/components/Button';
import CommentPost from 'flarum/components/CommentPost';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import reply from './utils/reply';
import LogInModal from 'flarum/forum/components/LogInModal';

export default function () {
  extend(CommentPost.prototype, 'actionItems', function (items) {

    const post = this.attrs.post;
    if (post.isHidden() || (app.session.user && (!post.discussion().canReply()))) return;
      items.add('reply',
      <Button className='Button Button--link reply-btn-lin' onclick={() => {
        // 判断是否被拉黑
        if (!app.session.user) {
          app.modal.show(LogInModal);
          return;
        }
        
        if(post.discussion().user().beIgnore() || post.user().beIgnore()) {
          AlertUtil.onWarn(app, app.translator.trans('dl-blackList.forum.be_ignore'));
          return;
        }
        reply(post);
        // if(post.user().id() == app.session.user.id()){
        //   // 如果是自己回复自己就不需要再验证了
        //   reply(post)
        // }else{
        //   res
        //   app.store.find('users', app.session.user.id()).then((res) => {
        //     let ignoreUsers = res.data.attributes.beIgnore;
        //     if(ignoreUsers && ignoreUsers.length>0){
        //       for(let user of ignoreUsers){
        //         if(user.user_id == post.user().id()){
        //           AlertUtil.onWarn(app, app.translator.trans('dl-blackList.forum.be_ignore'));
        //           return;
        //         }
        //       }
        //     }
        //     reply(post)
        //   });
        // }
      }}>
        <img className='icon-img' src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-pl.png`}></img>
        {app.translator.trans('flarum-mentions.forum.post.reply_link')}
      </Button>
    );
  });
}
